import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=6b3c42d6&scoped=true"
import script from "./JEditor.vue?vue&type=script&lang=js"
export * from "./JEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c42d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3c42d6')) {
      api.createRecord('6b3c42d6', component.options)
    } else {
      api.reload('6b3c42d6', component.options)
    }
    module.hot.accept("./JEditor.vue?vue&type=template&id=6b3c42d6&scoped=true", function () {
      api.rerender('6b3c42d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JEditor.vue"
export default component.exports